import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ipDefaultValue' })
export class IpDefaultValuePipe implements PipeTransform {
	public transform(value: string | undefined): string {
		return value ? value : '---.---.---.---';
	}
}
